<template>
  <div class="panel_settlement">
    <div style="padding-top: 7px">
      <span class="priceItem" style="margin-right: 20px">
        <span class="label">总计：</span>
        <span class="price">￥{{ saleTotal.total }}</span>
      </span>
      <span class="priceItem" style="margin-right: 0px">
        <span class="label">优惠：</span>
        <el-popover
          v-if="curDiscountCard && curDiscountCard._id"
          placement="top-start"
          title=""
          width="200"
          trigger="hover"
        >
          <span
            class="priceItem"
            style="font-size: 12px"
            v-if="curDiscountCard && curDiscountCard._id"
          >
            {{ curDiscountCard.coupon_name }}({{
              $public.getDiscountType(curDiscountCard.apply_range.order_type)
            }}券)
            <span v-if="curDiscountCard.activity_type === 1">
              满{{ curDiscountCard.money_top }}元可用
            </span>
            <span v-if="curDiscountCard.activity_type === 2">
              满{{ curDiscountCard.rebate_top }}元可用，
              <span v-if="curDiscountCard.rebate_limit > 0"
                >最高抵扣{{ curDiscountCard.rebate_limit }}元</span
              >
              <span v-else></span>
            </span>
            <span
              style="color: #1890ff; cursor: pointer"
              @click="delDiscountCard"
              >删除</span
            >
          </span>
          <span class="price" slot="reference"
            >￥{{
              $public.jian(
                saleTotal.total,
                $public.jian(saleTotal.activity, discountMoney)
              )
            }}</span
          >
        </el-popover>
        <span class="price" v-else
          >￥{{
            $public.jian(
              saleTotal.total,
              $public.jian(saleTotal.activity, discountMoney)
            )
          }}</span
        >
      </span>
    </div>
    <div>
      <span class="priceItem" style="margin-right: 5px">
        <span class="label">应付：</span>
        <span class="price" style="color: #ff2f2f"
          >￥{{ $public.jian(saleTotal.activity, discountMoney) }}</span
        >
      </span>
      <el-button
        style="width: 110px"
        type="warning"
        size="small"
        plain
        @click="delDiscountCard"
        v-if="curDiscountCard && curDiscountCard._id"
        >取消优惠券</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        size="small"
        plain
        @click="openDiscountCard"
        v-else
        >优惠券</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        size="small"
        plain
        @click="drawerRemark_state = true"
        >备注</el-button
      >
      <el-button
        style="width: 100px"
        type="warning"
        size="small"
        @click="submitOrder"
        >生成订单</el-button
      >
    </div>
    <!-- 优惠券 -->
    <div v-show="drawerDiscountCard_state">
      <drawerDiscountCard
        :userId="userInfo._id"
        :state="drawerDiscountCard_state"
        :money="saleTotal.activity"
        :type="2"
        @submit="submit_drawerDiscountCard"
      ></drawerDiscountCard>
    </div>
    <!-- 备注弹窗 -->
    <div v-if="drawerRemark_state">
      <drawerRemark
        :type="'jiyangguanli'"
        @submit="submit_drawerRemark"
      ></drawerRemark>
    </div>
  </div>
</template>
<script>
import drawerDiscountCard from "../../views/mendian/shouyin/drawer/discountCard.vue";
import drawerRemark from "../../views/mendian/shouyin/drawer/remark.vue";
export default {
  components: { drawerDiscountCard, drawerRemark },
  data() {
    return {
      o: null,
      // 优惠券
      drawerDiscountCard_state: false,
      // 备注
      drawerRemark_state: false,
    };
  },
  computed: {
    goodsItemsId() {
      return this.$store.state.jiyangguanli.goodsItemsId;
    },
    userInfo() {
      return this.$store.state.jiyangguanli.userInfo;
    },
    curPetInfo() {
      return this.$store.state.jiyangguanli.curPetInfo;
    },
    curDiscountCard() {
      return this.$store.state.jiyangguanli.curDiscountCard;
    },
    saleTotal() {
      return this.$store.state.jiyangguanli.saleTotal;
    },
    saleList() {
      return this.$store.state.jiyangguanli.ximeiList;
    },
    petWeight() {
      return this.$store.state.jiyangguanli.petWeight;
    },
    ximeiRemark() {
      return this.$store.state.jiyangguanli.ximeiRemark;
    },
    remark() {
      return this.$store.state.jiyangguanli.remark;
    },
    discountMoney() {
      return this.$store.state.jiyangguanli.discountMoney;
    },
  },
  mounted() {},
  methods: {
    // 创建订单
    submitOrder() {
      let petList = [];
      if (this.$public.isNull(this.saleList)) {
        this.$message({
          message: "请选择洗美服务",
          type: "error",
        });
        return;
      } else {
        let serviceList = [];
        for (let a = 0; a < this.saleList.length; a++) {
          if (this.$public.isNull(this.saleList[a].salesMans)) {
            this.$message({
              message: "请完善销售人员",
              type: "error",
            });
            return;
          }
          let salesMans = [];
          for (let b = 0; b < this.saleList[a].salesMans.length; b++) {
            salesMans.push({
              userId: this.saleList[a].salesMans[b].split(",")[0],
              userName: this.saleList[a].salesMans[b].split(",")[1],
            });
          }
          let activityType = 0;
          if (this.saleList[a].couponId) {
            activityType = 5;
          } else if (this.saleList[a].activityId) {
            activityType = 1;
          } else if (this.saleList[a].cardId) {
            activityType = 2;
          }
          serviceList.push({
            cardNum: this.saleList[a].cardId
              ? this.saleList[a].cardItem.card_number
              : "",
            cardName: this.saleList[a].cardId
              ? this.saleList[a].cardItem.card_name
              : "",
            activityType: activityType,
            salesMans: salesMans,
            goodsId: this.saleList[a].serviceId,
            goodsName: this.saleList[a].title,
            goodsType: 2,
            brand: this.saleList[a].brand,
            categoryId: this.saleList[a].category_info._id,
            categoryName: this.saleList[a].category_info.name,
            skus: this.saleList[a].skuItem.service_objectId,
            skuValue:
              (this.saleList[a].skuItem.extend_attr
                ? this.saleList[a].skuItem.extend_attr + " "
                : "") + this.saleList[a].skuItem.service_objectName,
            unitId: "",
            unit: this.saleList[a].skuItem.frequency_text,
            outUnit: this.saleList[a].skuItem.frequency_text,
            // originalPrice: this.saleList[a].cardId? this.saleList[a].cardItem.unit_price ||this.saleList[a].skuItem.originalPrice: this.saleList[a].skuItem.originalPrice,

            originalPrice: this.saleList[a].cardId? this.saleList[a].cardItem.unit_price: this.saleList[a].skuItem.originalPrice,
            price: this.saleList[a].skuItem.price,
            num: 1,
            activityId: this.saleList[a].activityId
              ? this.saleList[a].activityItem._id
              : "",
            activityName: this.saleList[a].activityId
              ? this.saleList[a].activityItem.name
              : "",
            totalMoney: 0,
            joinCommission: this.saleList[a].join_commission,
            isNeedCode: false,
          });
        }
        petList.push({
          petId: this.curPetInfo._id,
          petName: this.curPetInfo.nick_name,
          hsPet: this.curPetInfo.hs_pet,
          chip: this.curPetInfo.eprom_no,
          classType: this.curPetInfo.apply_type.value,
          className: this.curPetInfo.apply_type.title,
          typeName: this.curPetInfo.category_info.name,
          sex: this.curPetInfo.pet_sex,
          birthDay: this.curPetInfo.bron_date,
          weight: this.petWeight,
          // "roomId": obj[i].roomItem.room_id,
          // "roomName": obj[i].roomItem.room_name,
          // "cageId": obj[i].cageItem.cage_id,
          // "cageName": obj[i].cageItem.cage_name,
          services: serviceList,
          remark: this.ximeiRemark,
        });
      }
      /////////////////////////////////         洗美服务活动没有赠品 from洋洋
      let params = {
        memberId: this.userInfo._id,
        memberName: this.userInfo.basic_info.nick_name,
        memberMobile: this.userInfo.basic_info.user_mobile,
        memberGrades: this.userInfo.club_card. surplus_day,
        couponNo: this.curDiscountCard ? this.curDiscountCard._no : "",
        remark: this.remark,
        pets: petList,
        otherParam: this.goodsItemsId,
      };
      console.log(params, this.curDiscountCard);
      let loading = this.$loading();
      this.$http.post("/api/WashBeauty/Insert", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.$emit("submit", { type: "success" });
        }
      });
    },
    // 优惠券
    openDiscountCard() {
      if (this.saleList.length > 0) {
        let canCard = true;
        for (let i = 0; i < this.saleList.length; i++) {
          if (!this.$public.isNull(this.saleList[i].activityId)) {
            canCard = false;
          }
        }
        if (canCard === false) {
          this.$message({
            message: "选择活动后不可使用优惠券！！",
            type: "error",
          });
        } else {
          this.drawerDiscountCard_state = true;
        }
      } else {
        this.$message({
          message: "请添加服务",
          type: "error",
        });
      }
    },
    submit_drawerDiscountCard(obj) {
      if (obj.type === "submit") {
        // this.$store.commit('jiyangguanli/set_saleTotal',{total:this.saleTotal.total, activity:obj.newMoney})
        this.$store.commit(
          "jiyangguanli/set_discountMoney",
          this.$public.jian(this.saleTotal.activity, obj.newMoney)
        );
        this.$store.commit("jiyangguanli/set_curDiscountCard", obj.card);
        this.drawerDiscountCard_state = false;
      } else {
        this.drawerDiscountCard_state = false;
      }
    },
    delDiscountCard() {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // this.$store.commit('jiyangguanli/set_saleTotal',{total:this.saleTotal.total, activity:this.saleTotal.total})
        this.$store.commit("jiyangguanli/set_discountMoney", 0);
        this.$store.commit("jiyangguanli/set_curDiscountCard", null);
      });
    },
    // 备注
    submit_drawerRemark() {
      this.drawerRemark_state = false;
    },
  },
};
</script>
<style scoped lang="scss">
.panel_settlement {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #fff;
  box-shadow: 0 -3px 5px 0px #ccc;
  .priceItem {
    display: inline-flex;
    align-items: center;
    margin-right: 40px;
    .label {
      font-size: 14px;
      color: $fontColor;
    }
    .price {
      font-size: 20px;
      color: $fontColor;
    }
  }
}
</style>
